import React from 'react';

const Stats = () => {
  return (
    <section className="px-6 py-20 bg-white md:px-12">
      <div className="mx-auto text-center max-w-7xl">
        <h2 className="mb-4 text-4xl font-extrabold text-gray-800">Our Impact in Numbers</h2>
        <p className="max-w-2xl mx-auto mb-12 text-lg text-gray-600">
          At Blessed Montessori, numbers tell our story of growth, excellence, and trust across the globe.
        </p>

        <div className="grid grid-cols-2 gap-8 text-center sm:grid-cols-2 md:grid-cols-4">
          <div className="p-6 transition shadow-md bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl hover:shadow-xl">
            <h3 className="text-4xl font-bold text-blue-700">25+</h3>
            <p className="mt-2 text-gray-600">Years of Excellence</p>
          </div>

          <div className="p-6 transition shadow-md bg-gradient-to-br from-green-100 to-green-200 rounded-xl hover:shadow-xl">
            <h3 className="text-4xl font-bold text-green-700">3,000+</h3>
            <p className="mt-2 text-gray-600">Graduated Students</p>
          </div>

          <div className="p-6 transition shadow-md bg-gradient-to-br from-purple-100 to-purple-200 rounded-xl hover:shadow-xl">
            <h3 className="text-4xl font-bold text-purple-700">50+</h3>
            <p className="mt-2 text-gray-600">Qualified Staff</p>
          </div>

          <div className="p-6 transition shadow-md bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-xl hover:shadow-xl">
            <h3 className="text-4xl font-bold text-yellow-700">98%</h3>
            <p className="mt-2 text-gray-600">WAEC Pass Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
